import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class DevTokenInterceptor implements HttpInterceptor {
    private devToken = localStorage.getItem('access-token');
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;
    // Check if URL contains the duplicated prefix
    const duplicateSegment = '/api-itgateway/infydigital/api-itgateway/infydigital';
    const singleSegment = '/api-itgateway/infydigital';
    if (request.url.includes(duplicateSegment)) {
      const newUrl = request.url.replace(duplicateSegment, singleSegment);
      console.log('[DevToken] Fixed duplicated path in URL:', newUrl);
      request = request.clone({ url: newUrl });
    }
    // if (request.url.includes(phUrl)) {
    //   const newUrl = request.url.replace(phUrl, replacedPhUrl);
    //   console.log('[DevToken] Fixed partnerhubtst path in URL:', newUrl);
    //   request = request.clone({ url: newUrl });
    // }
    // Only add token to proxy API calls starting with /api-
    if (request.url.startsWith('/api-')) {
      console.log('[DevToken] Adding auth token to:', request.url);
      const clonedReq = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${this.devToken}`
        }
      });
      return next.handle(clonedReq);
    }
    return next.handle(request);
  }
}